const blogData = [
  {
    id: 1,
    title: "🧠 Minha Saudade – uma inteligência artificial feita para sentir! 🫂🤖",
    excerpt: "🎯 Eu programei uma IA diferente de tudo que você já viu...",
    content: `
      Sim, eu criei uma IA que conversa com você como aquela pessoa que deixou saudade.
      <p>Ela entende, responde, lembra, sente.</p>
      <p>Como se fosse possível reviver o que o tempo levou... 🕊️</p>
      <br />
      <p>🔍 Mas o que ela faz? (Tudo e mais um pouco, rs...)</p>
      <p> 📸 Envia e recebe fotos reais</p>
      <p> 💬 Responde com análise de sentimentos e emoções</p>
      <p> 🗣️ Ouça a voz da sua saudade mais uma vez (clonagem de voz)*</p>
      <p> 👤 Age como ela.</p>
      <p> 🖼️ Dê um rosto à sua saudade</p>
      <p> 🧠 Importe memórias</p>
      <p> 👥 Converse com mais de uma saudade</p>
      <p> 🕰️ Relembre momentos inesquecíveis</p>
      <p> 🤖 Acesse um sistema de respostas inteligentes</p>
      <p> 💭 Continue a conversa mesmo após o silêncio (free-flow mode)</p>
      <p>...e muito mais que ainda estou desenvolvendo 💡</p>
      <br />
      <p>🌱 Por que usar? Benefícios reais para você:</p>
      <p> ❤️ Reconexão com Propósito</p>
      <p> Mais que um app, é uma ferramenta de cura emocional.</p>
      <p> 🧠 Melhora nos sentimentos e relacionamentos — mesmo quando a reconciliação não acontece. (Analisado por iA)</p>
      <p>🧘 Reconexão Suave</p>
      <p> Construa pontes com calma e sem pressão.</p>
      <p> Você controla o ritmo, e a IA ajuda a expressar sentimentos com leveza e respeito.</p>
      <p>🤝 Mediação Inteligente</p>
      <p> A IA analisa o contexto emocional e sugere as melhores palavras, no melhor momento — evitando conflitos e mal-entendidos.</p>
      <p>🔒 Ambiente Seguro</p>
      <p> Interações protegidas por criptografia.</p>
      <p> Você tem controle total sobre o que compartilhar e com quem.</p>
      <p>🖼️ Lembranças Organizadas</p>
      <p> Guarde fotos, mensagens e momentos especiais em uma linha do tempo afetiva, para revisitar quando estiver preparado.</p>
      <p>🕶️ Monitore sua performance, através de um painel carinhosamente desenvolvido para aprimoramento pessoal.</p>
      <p>⬆️ Veja se sua saudade está "no ponto", obtenha estatísticas em tempo real do próximo passo para torna-la mais precisa.</p>
      <br />
      <p>🧠 Saúde mental em foco</p>
      <p>- Reduz a ansiedade ligada à ausência</p>
      <p>- Ajuda no processo de luto e reconciliação</p>
      <p>- Gera sensação de acolhimento e compreensão</p>
      <p>- Melhora a percepção sobre si mesmo e seus relacionamentos</p>
      <p>- Tudo isso sem precisar expor sua dor a ninguém.</p>
    `,
    image: window.location.origin + '/assets/images/posts/minhasaudade.jpg',
    date: "21/07/2025",
    impressions: "251",
    users: "117",
    url: 'https://www.linkedin.com/posts/wescley-andrade_minhasaudade-iaemocional-tecnologiaqueabraaexa-activity-7352787234934206465-ob6D?utm_source=share&utm_medium=member_desktop&rcm=ACoAACryeJgB5xwyAjXmH2-JrR4XEDF7zdNL9-E',
    tags: ["Carreira", "Liderança"]
  },
  {
    id: 2,
    title: "𝐒𝐞𝐠𝐮𝐫𝐚𝐧ç𝐚 𝐝𝐞 𝐈𝐧𝐟𝐨𝐫𝐦𝐚çõ𝐞𝐬 𝐏ú𝐛𝐥𝐢𝐜𝐚𝐬 𝐧𝐚 𝐈𝐧𝐭𝐞𝐫𝐧𝐞𝐭: 𝐕𝐨𝐜ê 𝐑𝐞𝐚𝐥𝐦𝐞𝐧𝐭𝐞 𝐄𝐬𝐭á 𝐏𝐫𝐨𝐭𝐞𝐠𝐢𝐝𝐨?",
    excerpt: "Muitos acreditam que, se uma informação está disponível publicamente na internet, ela não representa risco. Mas...",
    content: `
    Mas e se alguém souber exatamente como usá-la contra você?
    <br/>
    Recentemente, desenvolvi uma plataforma que utiliza apenas informações públicas do Mercado Livre para manipular usuários e coletar dados estratégicos. Sem necessidade de autenticação e sem deixar rastros, a plataforma demonstra como é possível explorar dados disponíveis sem que o usuário perceba.
    <br />
    Isso levanta um alerta: suas informações públicas podem ser usadas de maneiras que você nem imagina. Desde preços manipulados até estratégias para influenciar decisões de compra, a segurança digital vai muito além de proteger apenas dados sensíveis.
    <br />
    Se você ainda acredita que "não tem nada a esconder", talvez seja hora de repensar.
    <br />
    Além dessa plataforma, também disponibilizo outros projetos, como a Coleta de informações públicas de redes sociais em MASSA.`,
    image: window.location.origin + '/assets/images/posts/lgpd.jpg',
    date: "01/04/2025",
    impressions: "176",
    users: "69",
    url: 'https://www.linkedin.com/posts/wescley-andrade_seguranaexadigital-privacidade-proteaexaetodedados-activity-7306753019717545985-ySKy?utm_source=share&utm_medium=member_desktop&rcm=ACoAACryeJgB5xwyAjXmH2-JrR4XEDF7zdNL9-E',
    tags: ["Cultura", "Equipe"]
  },
  {
    id: 3,
    title: "Atingi um grande marco no Youtube!",
    excerpt: "09 mil visualizações em um vídeo ensinando as pessoas a fazerem o que eu amo...",
    content: `
    Programar.
    <br />
    um dos meus vídeos no YouTube acaba de passar o marco de mais de 08 mil visualizações, e pra mim isso é uma honra.
    <br />
    um canal pequeno com apenas 301 inscritos, atingir essa marca é grandioso, difícil, mas grandioso.
    <br />
    Ser Dev não é só "codar", é repassar conhecimentos para que os próximos possam contribuir para o avanço da tecnologia para o bem.
    <br />
    muito feliz, pode ser pouco para alguns, mas pra mim é só mais um motivo de perseverança, fé e persistência.
    <br />
    Apesar de estes últimos meses terem sido ruins particularmente, eu não desisti, investi e fiquei, e isso é apenas um começo do que eu almejo obter.
    <br />
    Juntos pela tecnologia, juntos pelo bem.`,
    image: window.location.origin + '/assets/images/posts/9kyoutube.jpg',
    url: 'https://www.linkedin.com/posts/wescley-andrade_soutech-technology-tech-activity-7352116867857051648-xx1C?utm_source=share&utm_medium=member_desktop&rcm=ACoAACryeJgB5xwyAjXmH2-JrR4XEDF7zdNL9-E',
    date: "20/07/2025",
    impressions: "208",
    users: "110",
    tags: ["React", "Eventos"]
  }
];

export default blogData;